import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SpotahomeLogo.module.scss';

const DIMENSIONS = {
  small: {
    width: 97,
    height: 18
  },
  normal: {
    width: 131,
    height: 24
  },
  large: {
    width: 190,
    height: 34
  }
};

const THEMES = {
  light: '#ffffff',
  dark: '#0D0D0D'
};

const SpotahomeLogo = ({ className, size, theme }) => {
  const logoClasses = classNames(styles['spotahome-logo'], className);

  return (
    <svg
      viewBox="0 0 97 18"
      width={`${DIMENSIONS[size].width}`}
      height={`${DIMENSIONS[size].height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={logoClasses}
      preserveAspectRatio="none"
    >
      <path
        d="M72.4761 3.63709H74.6257V4.73048C75.1686 3.8156 76.0017 3.30981 77.0802 3.30981C78.3967 3.30981 79.3116 3.8751 79.7207 5.01312C80.286 3.94205 81.2381 3.30981 82.4802 3.30981C84.3472 3.30981 85.381 4.42552 85.381 6.63461L85.4182 13.433H83.2463V7.17015C83.2463 5.86849 82.7777 5.32552 81.781 5.32552C80.7248 5.32552 80.0777 6.07676 79.9736 7.61643L80.0331 13.4404H77.9281V7.17015C77.9281 5.86849 77.4595 5.32552 76.4257 5.32552C75.31 5.32552 74.6182 6.21808 74.6182 7.9437V13.4404H72.4686V3.63709H72.4761Z"
        fill={THEMES[theme]}
      />
      <path
        d="M9.31262 3.61477H11.544V4.76767C12.3325 3.79329 13.4333 3.30981 14.787 3.30981C17.4424 3.30981 19.3688 5.60072 19.3688 8.52387C19.3688 11.4247 17.4424 13.7528 14.787 13.7528C13.4259 13.7528 12.3548 13.2693 11.544 12.2726V17.9999H9.31262V3.61477ZM17.1374 8.52387C17.1374 6.73874 15.9994 5.4594 14.3184 5.4594C12.6746 5.4594 11.544 6.73874 11.544 8.52387C11.544 10.309 12.6969 11.6106 14.3184 11.6106C15.9622 11.6106 17.1374 10.309 17.1374 8.52387Z"
        fill={THEMES[theme]}
      />
      <path
        d="M30.2803 8.54633C30.2803 11.4918 28.2125 13.7381 25.1927 13.7381C22.1952 13.7381 20.0828 11.4844 20.0828 8.54633C20.0828 5.60831 22.21 3.3174 25.1927 3.3174C28.1976 3.30996 30.2803 5.60831 30.2803 8.54633ZM27.2456 10.7331C27.796 10.1455 28.0563 9.41658 28.0563 8.53889C28.0563 7.66864 27.796 6.93972 27.2456 6.35211C26.6952 5.76451 26.0257 5.45955 25.2001 5.45955C24.3671 5.45955 23.6753 5.7422 23.1324 6.3298C22.5819 6.9174 22.3216 7.64633 22.3216 8.53889C22.3216 9.40914 22.5819 10.1455 23.1324 10.7331C23.6828 11.3058 24.3671 11.5885 25.2001 11.5885C26.0257 11.5885 26.6952 11.3058 27.2456 10.7331Z"
        fill={THEMES[theme]}
      />
      <path
        d="M47.4026 4.7751V3.61477H49.6117V13.433H47.4026V12.2801C46.6141 13.2544 45.5133 13.7379 44.1596 13.7379C41.5042 13.7379 39.5778 11.447 39.5778 8.52387C39.5778 5.64535 41.5042 3.30981 44.1596 3.30981C45.5133 3.30981 46.5844 3.80072 47.4026 4.7751ZM46.6067 10.7181C47.1348 10.1305 47.3951 9.40155 47.3951 8.52387C47.3951 7.65362 47.1274 6.91725 46.6067 6.35197C46.0786 5.76436 45.4092 5.48172 44.5984 5.48172C43.7877 5.48172 43.1183 5.76436 42.5902 6.35197C42.0621 6.91725 41.8017 7.65362 41.8017 8.52387C41.8017 10.309 42.9621 11.566 44.5984 11.566C45.4315 11.566 46.1009 11.2834 46.6067 10.7181Z"
        fill={THEMES[theme]}
      />
      <path
        d="M51.2777 0H53.5091V4.64876C54.238 3.7562 55.2347 3.30992 56.4918 3.30992C58.6637 3.30992 59.9207 4.7529 59.9207 7.10331V13.4331H57.6893V7.52728C57.6893 6.04711 57.0645 5.31819 55.7852 5.31819C54.4091 5.31819 53.5166 6.38926 53.5166 8.11488V13.4331H51.2851V0H51.2777Z"
        fill={THEMES[theme]}
      />
      <path
        d="M71.3826 8.54633C71.3826 11.4918 69.3148 13.7381 66.295 13.7381C63.2975 13.7381 61.1851 11.4844 61.1851 8.54633C61.1851 5.60831 63.3123 3.3174 66.295 3.3174C69.2925 3.30996 71.3826 5.60831 71.3826 8.54633ZM68.3404 10.7331C68.8909 10.1455 69.1512 9.41658 69.1512 8.53889C69.1512 7.66864 68.8834 6.93972 68.3404 6.35211C67.79 5.76451 67.1206 5.45955 66.2875 5.45955C65.4545 5.45955 64.7628 5.7422 64.2198 6.3298C63.6768 6.9174 63.409 7.64633 63.409 8.53889C63.409 9.40914 63.6768 10.1455 64.2198 10.7331C64.7702 11.3058 65.4619 11.5885 66.2875 11.5885C67.128 11.5885 67.79 11.3058 68.3404 10.7331Z"
        fill={THEMES[theme]}
      />
      <path
        d="M36.8405 9.82563C36.8628 11.0008 36.2752 11.7149 35.3381 11.7149C34.3637 11.7149 33.7761 11.1273 33.7761 10.0488V5.56364H38.6033V3.61488H33.7686V0H31.5372V9.98182C31.5372 12.3174 32.9951 13.738 35.4124 13.738C37.5397 13.738 39.0868 12.1984 38.9604 9.82563H36.8405Z"
        fill={THEMES[theme]}
      />
      <path
        d="M4.27686 7.20743C2.99752 7.06611 2.63306 6.76115 2.63306 6.21074C2.63306 5.66033 3.19835 5.35537 4.0686 5.35537C4.94628 5.35537 5.54876 5.8314 5.83141 6.66446L7.75785 6.06942C7.21488 4.38099 5.76446 3.2876 4.0686 3.2876C2.00826 3.29504 0.423967 4.52975 0.423967 6.21074C0.423967 7.99586 1.65868 9.11157 4.03141 9.35702C5.57107 9.52066 6.09917 9.90744 6.09917 10.5322C6.09917 11.2017 5.42975 11.6926 4.23223 11.6926C3.13884 11.6926 2.3876 11.105 2.03802 10.1529L0 10.7777C0.260331 11.5438 0.684298 12.1983 1.29421 12.719C2.10496 13.3884 3.07934 13.7306 4.23223 13.7306C6.58265 13.7306 8.27108 12.3917 8.27108 10.4281C8.27851 8.54628 6.93223 7.4752 4.27686 7.20743Z"
        fill={THEMES[theme]}
      />
      <path
        d="M93.7935 10.1455C93.4811 11.1199 92.6555 11.7446 91.5323 11.7446C89.9703 11.7446 88.9513 10.7331 88.7058 9.04464H96.0547V8.01076C96.0547 5.25125 94.1431 3.30249 91.4877 3.30249C88.5868 3.30249 86.6157 5.5934 86.6157 8.53142C86.6157 11.4918 88.5124 13.7232 91.4951 13.7232C93.5555 13.7232 95.2439 12.5256 95.8092 10.7554L93.7935 10.1455ZM91.4877 5.23638C92.8637 5.23638 93.972 6.15125 94.0315 7.30415H88.81C89.1521 6.06943 90.1637 5.23638 91.4877 5.23638Z"
        fill={THEMES[theme]}
      />
    </svg>
  );
};

SpotahomeLogo.propTypes = {
  className: PropTypes.string,
  size: PropTypes.string,
  theme: PropTypes.oneOf(['dark', 'light'])
};

SpotahomeLogo.defaultProps = {
  className: '',
  size: 'normal',
  theme: 'dark'
};

export default SpotahomeLogo;
